import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Observable, Subject, map, takeUntil } from "rxjs";
import {
    MonitoringSiteObservationDto,
    MonitoringSiteObservationModel,
} from "src/app/models/monitoringSiteObservation.model";

import { AirNowService } from "src/app/services/airNow.service";
import { MatDialog } from "@angular/material/dialog";
import { CommonService } from "src/app/services/common.service";
import { SensorService } from "src/app/services/sensor.service";
import { ToastService } from "src/app/services/toast.service";
import { NodeAssignmentDialogComponent } from "src/app/modals/node-assignment-dialog/node-assignment-dialog.component";

@Component({
  standalone: false,
    selector: "app-info-window",
    templateUrl: "./info-window.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./info-window.component.scss"],
})
export class InfoWindowComponent implements OnInit, OnDestroy {
    @Input() siteId: string;
    @Input() latitude: number;
    @Input() longitude: number;

    observations: MonitoringSiteObservationModel[];
    observation: MonitoringSiteObservationModel;
    isFormLoading = false;
    isLoading = false;
    readonly organizationLevelId$: Observable<string | null>;

    private readonly destroy$ = new Subject<void>();

    constructor(
        private airNowService: AirNowService,
        private sensorService: SensorService,
        private commonService: CommonService,
        private dialog: MatDialog,
        private toastService: ToastService,
    ) {
        this.organizationLevelId$ = this.commonService.selectedOrgEmitter.pipe(
            map((org) => org?.id ?? null),
        );
    }

    ngOnInit(): void {
        const payload = new MonitoringSiteObservationDto([
            this.longitude - 0.01,
            this.latitude - 0.01,
            this.longitude + 0.01,
            this.latitude + 0.01,
        ]);
        this.isFormLoading = true;
        this.airNowService
            .getObservationsByMonitoringSite(payload)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (result) => {
                    const observations = result.filter(
                        (x) => x.intlAQSCode === this.siteId,
                    );
                    if (observations.length > 0) {
                        this.observation = observations[0];
                    }
                    this.observations = observations;
                    this.isFormLoading = false;
                },
                error: (error) => {
                    this.toastService.showError(error);
                    this.isFormLoading = false;
                },
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    assign() {
        const organizationLevelId = this.commonService.getSelectedOrganizationLevelId();
        if (!organizationLevelId) {
            return;
        }
        this.isLoading = true;
        this.sensorService
            .getOrCreateSensorByAirNowSiteId(this.siteId, organizationLevelId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (sensor) => {
                    this.dialog.open(NodeAssignmentDialogComponent, {
                        data: {
                            sensorId: sensor.id,
                            sensorName: sensor.name,
                            organizationLevelId,
                        },
                        width: "450px",
                        disableClose: true,
                    });
                    this.isLoading = false;
                },
                error: (error) => {
                    this.toastService.showError(error);
                    this.isLoading = false;
                },
            });
    }

    public trackByIndex = trackByIndex;
}
